import type { ApiPromise } from '../../utility';
import { apiCall } from '../client';
import type { ActionsFindAllRequest, ActionsFindAllResponse } from '../schema';

const path = 'actions';

export default {
  findAll: async (request: ActionsFindAllRequest): ApiPromise<ActionsFindAllResponse> => {
    return await apiCall('POST', path, request);
  }
};
